import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/index',
    meta: {
      title: '控制台',
      keepAlive: true,
      requiresAuth: true,
    },
    children: [
      {
        path: 'index',
        name: 'DashboardIndex',
        component: () => import('@/views/app/dashboard/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '控制台',
        }
      }
    ]
  }
]

export default router
